<template>
	<div>
		<b-modal
			ref="assign-knife-modal"
			@hidden="handleCloseModal"
			no-close-on-backdrop
			no-close-on-esc
			cancel-title="Cancelar"
			size="md"
			hide-footer
		>
			<template #modal-header>
				<div class="d-flex justify-content-between align-items-center w-100">
					<div class="font-weight-bold">Asignar Navaja a {{ selectedSpecimen.plate }}</div>
					<div class="d-flex gap-x-2">
						<div style="display: flex; gap: 0.5rem">
							<b-button variant="success" @click="assignKnife" v-b-tooltip.hover="'Guardar'">
								<FeatherIcon icon="SaveIcon" />
							</b-button>
						</div>
						<div style="display: flex; gap: 0.5rem">
							<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
								<FeatherIcon icon="XIcon" />
							</b-button>
						</div>
					</div>
				</div>
			</template>
			<ValidationObserver ref="form">
				<div class="d-flex justify-content-center align-items-center gap-x-1">
					<b-form-group id="input-group-1" label="Seleccionar Código:" label-for="input-1" class="w-100">
						<ValidationProvider rules="required" v-slot="{ errors }">
							<v-select
								v-model="code"
								:options="codes"
								placeholder="Seleccionar Código"
								:clearable="false"
								class="w-100"
							></v-select>
							<span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
						</ValidationProvider>
					</b-form-group>
					<b-form-group id="input-group-1" label="Seleccionar Serie:" label-for="input-1" class="w-100">
						<ValidationProvider rules="required" v-slot="{ errors }">
							<v-select
								v-model="knifeId"
								label="series"
								:options="series"
								:reduce="(opt) => opt.id"
								placeholder="Seleccionar Navaja"
								:clearable="false"
								class="w-100"
							></v-select>
							<span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
						</ValidationProvider>
					</b-form-group>
				</div>
				<b-form-group label="Tamaño(cm)" label-for="size">
					<b-form-input id="size" v-model="size" type="number" placeholder="Opcional" />
				</b-form-group>
				<!-- <b-form-group label="Observaciones" label-for="observations">
					<b-form-textarea id="observations" v-model="observations" rows="5" placeholder="Opcional" />
				</b-form-group> -->
			</ValidationObserver>
		</b-modal>
	</div>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"
import debounce from "lodash/debounce"

export default {
	name: "AssignKnifeModal",
	components: {},
	props: {
		selectedSpecimen: {
			type: Object,
			required: true,
		},
		isFromManageFrontModal: {
			type: Boolean,
			default: false,
		},
	},
	async mounted() {
		this.getCodes()
		this.$refs["assign-knife-modal"].toggle()
	},
	computed: {},
	data() {
		return {
			loading: false,
			debouncedGetKnives: null,
			codes: [],
			series: [],
			searchText: "",
			code: null,
			knifeId: null,
			size: null,
			observations: null,
		}
	},
	watch: {
		code(newCode) {
			this.getSeries()
		},
	},
	created() {
		this.debouncedGetKnives = debounce(this.getActiveKnives, 300)
	},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},

		async getCodes() {
			try {
				const { data } = await TournamentKnivesService.getCodes()
				this.codes = data
			} catch (error) {
				console.error("Error creating knife:", error)
			}
		},

		async getSeries() {
			try {
				const { data } = await TournamentKnivesService.getSeries(this.code)
				this.series = data
			} catch (error) {
				console.error("Error creating knife:", error)
			}
		},

		async getActiveKnives(searchText = "") {
			if (this.searchText === searchText || searchText === "") return
			this.searchText = searchText
			try {
				const params = {
					searchTerm: searchText,
				}
				const { data } = await TournamentKnivesService.getActives(params)
				this.knives = data
			} catch (error) {
				console.log(error.message)
				this.showToast("danger", "top-right", "Navajas", "AlertCircleIcon", error.message)
			}
		},

		async assignKnife() {
			if (!(await this.$refs.form.validate())) return
			try {
				const series = this.series.find((it) => it.id == this.knifeId)
				const knifeInfo = {
					specimen_id: this.selectedSpecimen.id,
					knife_id: this.knifeId,
					knife_code: this.code,
					knife_series: series.series,
					knife_size: this.size,
				}
				if (
					!this.selectedSpecimen.tournament.tournament_event_front_specimen_id &&
					!this.isFromManageFrontModal
				) {
					this.$emit("setKnife", knifeInfo)
					this.$emit("close")
					return
				}
				const { data } = await TournamentKnivesService.assignKnife({
					knife_id: this.knifeId,
					specimen_id: this.selectedSpecimen.id,
					size: this.size,
					tournament_event_front_specimen_id:
						this.selectedSpecimen.tournament.tournament_event_front_specimen_id,
					observations: this.observations,
				})
				this.showToast("success", "top-right", "Navajas", "CheckCircleIcon", "Navaja asignada correctamente")
				this.$emit("refresh")
				this.$emit("close")
			} catch (error) {
				console.log(error.message)
				this.showToast("danger", "top-right", "Navajas", "AlertCircleIcon", error.message)
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>
